import { FC } from "react";
import { IMonth } from "../scheduleFeedList/types"
import { ScheduleFeedItem } from "../scheduleFeedItem/scheduleFeedItem";
import { formatWithLocale, getShortDayOfWeek } from "shared/lib/date";
import styles from './styles.module.scss';

type ScheduleFeedMonthProps = {
  month: IMonth;
	changeDayActive?: (date: string) => void;
}

export const ScheduleFeedMonth: FC<ScheduleFeedMonthProps> = ({
  month,
  changeDayActive
}) => {
  return (
    <div className={styles['schedule-feed-list__month']}>
      <span className={styles['schedule-feed-list__monthname']}>{month.month}</span>
      <div className={styles['schedule-feed-list__days']}>
        {month.days.map((day) => (
          <ScheduleFeedItem
            key={day.date}
            date={day.date}
            day={formatWithLocale(day.date, 'd')}
            dayOfWeek={getShortDayOfWeek(day.date)}
            isDisable={day.has_slots === false}
            isActive={day.isActive}
            selectDay={changeDayActive}
          />
        ))}
      </div>
    </div>
  )
}